import { render, staticRenderFns } from "./ProductDetailTiles.vue?vue&type=template&id=60c49236&"
import script from "./ProductDetailTiles.vue?vue&type=script&lang=js&"
export * from "./ProductDetailTiles.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailTiles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports